import React, { useState } from 'react';
import { getPropertyListingMode, resolveListingAgentFields } from '../../utils/properties';
import ListingAgentAvatar, { listingAgentInitials } from './ListingAgentAvatar';

export { listingAgentInitials };

const ListingAgentProfileCard = ({ property, onMessage, compact = false }) => {
  const [phoneVisible, setPhoneVisible] = useState(false);
  const resolved = resolveListingAgentFields(property);
  const name = String(resolved?.agentName || "").trim() || "Listing agent";
  const company = String(resolved?.agentCompany || "").trim();
  const phone = String(resolved?.agentPhone || "").trim();
  const email = String(resolved?.agentEmail || "").trim();
  const avatarUrl = resolved?.agentAvatarUrl || null;
  const kycApproved = resolved?.agentKycApproved === true;
  const propType = String(property?.type || "").trim() || (getPropertyListingMode(property) === "rent" ? "Residential" : "Residential");
  const listingModeLabel = getPropertyListingMode(property) === "rent" ? "For rent" : "For sale";
  const hasContact = !!(email && onMessage);
  const showCompanySection = !!(company && company.toLowerCase() !== name.toLowerCase());
  const consultationTarget = showCompanySection ? company : name;
  const listingKind = getPropertyListingMode(property) === "rent" ? "rental" : "listing";
  const companyInitials = company
    ? company.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase()
    : listingAgentInitials(name);

  const openChat = (intent) => {
    if (!onMessage) return;
    const draft = intent === "consultation"
      ? `Hello, I would like to request a free, no-obligation consultation about this ${listingKind}. Please let me know your availability.`
      : "";
    onMessage(property, { intent, draft });
  };

  return (
    <div className={`listing-agent-card${compact ? " listing-agent-card--compact" : ""}`}>
      <div className="listing-agent-card-section">
        <div className="listing-agent-card-top">
          <ListingAgentAvatar name={name} avatarUrl={avatarUrl} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <h4>{name}</h4>
            {phone ? (
              <div style={{ marginTop: "0.35rem" }}>
                {phoneVisible ? (
                  <a href={`tel:${phone.replace(/[^\d+]/g, "")}`} className="listing-agent-phone-link">{phone}</a>
                ) : (
                  <button type="button" className="listing-agent-phone-link" onClick={() => setPhoneVisible(true)}>
                    Show phone number
                  </button>
                )}
              </div>
            ) : null}
            {!showCompanySection ? (
              <>
                <div className="listing-agent-meta-row">
                  <span className="listing-agent-type-pill">{propType}</span>
                  <span aria-hidden="true">·</span>
                  <span>{listingModeLabel}</span>
                </div>
                {kycApproved ? (
                  <div className="listing-agent-meta-row">
                    <span className="listing-agent-verified listing-agent-verified--gold">
                      <i className="fas fa-shield-alt" aria-hidden="true"></i> Identity verified
                    </span>
                  </div>
                ) : null}
              </>
            ) : null}
          </div>
        </div>
        <button
          type="button"
          className="listing-agent-message-btn"
          disabled={!hasContact}
          onClick={() => openChat("message")}
        >
          <i className="fas fa-envelope" aria-hidden="true"></i> Message
        </button>
      </div>
      {showCompanySection ? (
        <div className="listing-agent-card-section listing-agent-card-company">
          <div className="listing-agent-card-company-row">
            <div className="listing-agent-company-logo" aria-hidden="true">{companyInitials}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <strong>{company}</strong>
              <div className="listing-agent-meta-row">
                <span className="listing-agent-type-pill">{propType}</span>
                <span aria-hidden="true">·</span>
                <span>{listingModeLabel}</span>
              </div>
              {kycApproved ? (
                <div className="listing-agent-meta-row">
                  <span className="listing-agent-verified listing-agent-verified--gold">
                    <i className="fas fa-shield-alt" aria-hidden="true"></i> Identity verified
                  </span>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
      <div className="listing-agent-card-section listing-agent-card-cta">
        <p>
          Get a free, no-obligation consultation about this {listingKind}
          {consultationTarget ? ` with ${consultationTarget}` : ""}.
        </p>
        <button
          type="button"
          className="listing-agent-consultation-btn"
          disabled={!hasContact}
          onClick={() => openChat("consultation")}
        >
          Request a consultation now
        </button>
      </div>
    </div>
  );
};

export default ListingAgentProfileCard;
